// Domain
import { InvestorProfileInvestmentExperienceRepository }
  from '../../../domain/repositories/investor-profile-investment-experience-repository';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class InvestorProfileInvestmentExperienceDummyRepository
implements InvestorProfileInvestmentExperienceRepository {
  update(): Promise<void> {
    return Promise.resolve();
  }
}
